import { getTermsValue, resetTerms, setTerms, TJsonQueryTermsKeys } from '../../../JsonQuery';
import { TTagsManager } from '../types/tag';
import { createTagValue } from './createTagValue';
import { fillLabelTemplate } from './fillLabelTemplate';

interface IParams {
  jsonQueryKey: TJsonQueryTermsKeys;
  mapValueToLabel?: Record<string | number, string>;
  template?: string;
  id: string;
}

export const createTermsTagsManager = ({ jsonQueryKey, mapValueToLabel, template, id }: IParams): TTagsManager => ({
  id,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const termValues = getTermsValue(jsonQueryKey)(jsonQuery);

    if (termValues === null) {
      return null;
    }

    return termValues.map(termValue => {
      let label = '';

      if (template && mapValueToLabel) {
        label = fillLabelTemplate(template, mapValueToLabel[termValue]);
      } else if (template) {
        label = fillLabelTemplate(template, termValue.toString());
      } else if (mapValueToLabel) {
        label = mapValueToLabel[termValue];
      }

      return {
        label,
        value: createTagValue(id, termValue.toString()),
      };
    });
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const terms = getTermsValue(jsonQueryKey)(jsonQuery);

    if (terms === null) {
      return jsonQuery;
    }

    const filteredTerms = terms.filter(term => String(term) !== removingTagValue);

    return filteredTerms.length
      ? setTerms(jsonQueryKey)(jsonQuery)(filteredTerms)
      : resetTerms([jsonQueryKey])(jsonQuery);
  },
});
